export const fetchData = async (endpoint) => {
  let result = {};
  let response;

  try {
    response = await fetch(`${endpoint}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      }
    });

    if (response.status === 200) {
      result = await response.json();
    }

    if (response.status === 403 || response.status === 404) {
      result = { statusCode: response.status };
    }
  } catch (e) {
    result = e;
  }

  // console.log('result', result);

  return result;
}

const sendData = async (
  endpoint,
  body,
  {
    method = 'POST',
    contentType = 'application/x-www-form-urlencoded',
    withoutURLSearchParams = false,
  },
) => {
  let response;
  let result = [];

  try {
    response = await fetch(endpoint, {
      method,
      headers: {
        Accept: 'application/json',
        'Content-Type': contentType,
      },
      body: withoutURLSearchParams ? body : new URLSearchParams(body),
    });

    if ([403, 404].includes(response.status)) {
      result = { statusCode: response.status };
    } else if ([400, 500].includes(response.status)) {
      const { error, message } = await response.json();

        const errors = {};

        if (Array.isArray(message)) {
          message.forEach((item) => {
            errors[item.property] = item.constraints && Object.values(item.constraints);
          });
        } else {
          errors.message = message;
        }

        result = {
          statusCode: response.status,
          errors,
          error,
          message,
        };
    } else {
      result = await response.json();
    }
  } catch (e) {
    if (e.response && !e.message.includes('JSON') && [401, 403, 500].includes(e.response.status)) {
      result = { statusCode: e.response.status };
    } else if (e.message.includes('JSON')) {
      result = { statusCode: 500 };
    } else {
      result = e;
    }
  }

  return result;
};

export const postData = (endpoint, body, options = {}) => sendData(
  endpoint,
  body,
  {
    ...options,
    method: 'POST',
  },
);

export const putData = (endpoint, body) => sendData(
  endpoint,
  body,
  { method: 'PUT' },
);

export const deleteData = (endpoint, body) => sendData(
  endpoint,
  body,
  { method: 'DELETE' },
);

export const patchData = (endpoint, body) => sendData(
  endpoint,
  body,
  { method: 'PATCH' },
);
